import { useMutation, useQuery, useQueryClient } from 'react-query';
import { checkConsequencesBeforeMediaDeleteAPI, getBlobsAPI, getMediaFilesAPI } from '@myme/api';
import { checkConsequencesBeforeMediaDelete, deleteMediaFile } from '@myme/logic';
import { UUID } from '@myme/utils';
import { useTranslation } from 'src/hooks';
import { handleError, toast, ToastType } from 'src/utils';
import { useMediaContext } from 'src/components/logic';

export const useDeleteMediaFile = (fileUUID: UUID) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { clearFileUUID } = useMediaContext();

  const handleDeleteMediaFile = useMutation(
    async () => {
      await deleteMediaFile(fileUUID);
    },
    {
      onSuccess: () => {
        toast(ToastType.SUCCESS, t('pages.mymes.editor.blobs.library.media_delete_toast_success'));
        clearFileUUID();
        queryClient.refetchQueries(getMediaFilesAPI.cacheKeys);
        queryClient.refetchQueries(getBlobsAPI.cacheKeys);
      },
      onError: err => {
        handleError(err, { displayCustomToast: () => toast(ToastType.ERROR, t('errors.blobs.delete_media')) });
      }
    }
  );

  return { handleDeleteMediaFile };
};

export const useHandleDeleteMediaFileConsequencesQuery = (fileId: UUID) => {
  const handleDeleteMediaFileConsequencesQuery = useQuery(
    [...checkConsequencesBeforeMediaDeleteAPI.cacheKeys, fileId],
    async () => {
      const { data } = await checkConsequencesBeforeMediaDelete(fileId);

      return data;
    }
  );

  return handleDeleteMediaFileConsequencesQuery;
};
